import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array-buffer.constructor.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.array-buffer.detached.js";
import "core-js/modules/es.array-buffer.transfer.js";
import "core-js/modules/es.array-buffer.transfer-to-fixed-length.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-reversed.js";
import "core-js/modules/es.typed-array.to-sorted.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.typed-array.with.js";
import "core-js/modules/es.uint8-array.set-from-base64.js";
import "core-js/modules/es.uint8-array.set-from-hex.js";
import "core-js/modules/es.uint8-array.to-base64.js";
import "core-js/modules/es.uint8-array.to-hex.js";
import "core-js/modules/web.atob.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-exception.constructor.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/web.dom-exception.to-string-tag.js";
import { getDictNotTreeByCateId, getDictTreeByCateId, savePersonnel, editPersonnel, resetPassWord } from '@/services/system';
import { getPersonnelList, updateUserSignature } from '@/api/personalApi.js';
import config from '@/pathConfig';
import CryptoJS from 'crypto-js';
export default {
  data: function data() {
    var IDValidator = function IDValidator(rule, value, callback) {
      var idcardReg = /^[1-9][0-9]{5}(19|20)[0-9]{2}((01|03|05|07|08|10|12)(0[1-9]|[1-2][0-9]|31)|(04|06|09|11)(0[1-9]|[1-2][0-9]|30)|02(0[1-9]|[1-2][0-9]))[0-9]{3}([0-9]|x|X)$/;
      if (!idcardReg.test(value)) {
        callback(new Error('请输入正确身份证号'));
      } else {
        callback();
      }
    };
    // let officeTelValidator = (rule, value, callback) => {
    //     const telReg = /^((([0-9]{3}-)?[0-9]{8})|(([0-9]{4}-)?[0-9]{7}))(-[0-9]{1,4})?$/
    //     if (!telReg.test(value)) {
    //         callback(new Error('请输入正确办公座机号'));
    //     } else {
    //         callback();
    //     }
    // }
    var phoneValidator = function phoneValidator(rule, value, callback) {
      var telReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!telReg.test(value)) {
        callback(new Error('请输入正确号码'));
      } else {
        callback();
      }
    };
    return {
      mode: 'edit',
      headers: {},
      contentLocation: [],
      targetOffset: undefined,
      current: 0,
      anchorList: [{
        id: 'jbxx',
        name: '基本信息'
      }, {
        id: 'xlxx',
        name: '学历信息'
      }, {
        id: 'gzjl',
        name: '工作经历'
      }, {
        id: 'gwxx',
        name: '岗位信息'
      }, {
        id: 'jszgz',
        name: '教师资格证'
      }, {
        id: 'pthzs',
        name: '普通话证书'
      }, {
        id: 'zczs',
        name: '职称证书'
      }, {
        id: 'qmtp',
        name: '签名图片'
      }],
      signatureModalVisible: false,
      isSignatureDrawing: false,
      signatureCtx: null,
      signatureLastX: 0,
      signatureLastY: 0,
      infoForm: {
        name: undefined,
        homeAddress: undefined,
        sex: undefined,
        physicalCondition: undefined,
        idCard: undefined,
        maritalStatus: undefined,
        age: undefined,
        degreeInNature: undefined,
        nation: undefined,
        officeTel: undefined,
        nativePlace: undefined,
        emergencyContact: undefined,
        politicsStatus: undefined,
        emergencyContactPhone: undefined,
        mobile: undefined,
        modeOfEmployment: undefined,
        birthPlace: undefined,
        prepareType: undefined,
        certType: undefined,
        isApplicable: undefined,
        householdRegistrationType: undefined,
        initDegree: undefined,
        initGraduationDate: undefined,
        initDegreeFromUniversity: undefined,
        initDegreeGraduationMajor: undefined,
        initAcademicOfStudy: undefined,
        initOfSchooling: undefined,
        initDegreeGraduate: undefined,
        initDiplomaCertNumber: undefined,
        initDegreeCertNumber: undefined,
        highestDegree: undefined,
        highestGraduationDate: undefined,
        highestDegreeFromUniversity: undefined,
        highestDegreeGraduationMajor: undefined,
        highestAcademicOfStudy: undefined,
        highestOfSchooling: undefined,
        highestDegreeGraduate: undefined,
        highestDiplomaCertNumber: undefined,
        highestDegreeCertNumber: undefined,
        proExpertise: undefined,
        overseasStudy: undefined,
        originalWorkUnit: undefined,
        workOfTime: undefined,
        enterOrganTime: undefined,
        enterSystemTime: undefined,
        department: undefined,
        subject: undefined,
        grade: undefined,
        inDepartment: undefined,
        isRegularEmployee: undefined,
        isTeacher: undefined,
        post: undefined,
        level: undefined,
        isTeaching: undefined,
        teachCertType: undefined,
        teacherCertSubject: undefined,
        teacherCertNumber: undefined,
        certOrgan: undefined,
        mandarinLevel: undefined,
        mandarinNumber: undefined,
        mandarinCertTime: undefined,
        professionalName: undefined,
        professionalTitle: undefined,
        reviewOrgan: undefined,
        examOrgan: undefined,
        professionalCertNumber: undefined,
        signImgUrl: undefined,
        signImgName: undefined,
        resignationTime: undefined,
        avatarUrl: undefined
      },
      sexDict: [{
        id: 'Sex001',
        name: '男'
      }, {
        id: 'Sex002',
        name: '女'
      }],
      healthDict: [],
      healthDictTree: [],
      healthDictOpt: [],
      marriageDict: [],
      degreeNatureDict: [],
      nationDict: [],
      nativePlaceDict: [],
      politicsStatusDict: [],
      modeOfEmploymentDict: [],
      prepareTypeDict: [],
      certTypeDict: [],
      isApplicableDict: [{
        id: 'yes',
        name: '是'
      }, {
        id: 'no',
        name: '否'
      }],
      householdRegistrationTypeDict: [],
      graduationMajorDict: [],
      initAcademicOfStudyDict: [],
      initOfSchoolingDict: [],
      overseasStudyDict: [{
        id: 'yes',
        name: '是'
      }, {
        id: 'no',
        name: '否'
      }],
      isRegularEmployeeDict: [{
        id: 'yes',
        name: '是'
      }, {
        id: 'no',
        name: '否'
      }],
      isTeacherDict: [{
        id: 'yes',
        name: '是'
      }, {
        id: 'no',
        name: '否'
      }],
      levelDict: [],
      levelDictTree: [],
      levelDictOpt: [],
      isTeachingDict: [{
        id: 'yes',
        name: '是'
      }, {
        id: 'no',
        name: '否'
      }],
      teachCertTypeDict: [],
      teacherCertSubjectDict: [],
      mandarinLevelDict: [],
      previewVisible: false,
      previewImage: '',
      fileList: [],
      fileListAvatar: [],
      rules: {
        name: [{
          required: true,
          message: '请输入姓名',
          trigger: 'blur'
        }],
        // homeAddress: [{
        //     required: true,
        //     message: '请输入家庭住址',
        //     trigger: 'blur'
        // }],
        // sex: [{
        //     required: true,
        //     message: '请选择性别',
        //     trigger: 'change'
        // }],
        // physicalCondition: [{
        //     required: true,
        //     message: '请选择健康情况',
        //     trigger: 'change'
        // }],
        idCard: [{
          required: true,
          validator: IDValidator,
          trigger: 'blur'
        }],
        // maritalStatus: [{
        //     required: true,
        //     message: '请选择婚姻状况',
        //     trigger: 'change'
        // }],
        // age: [{
        //     required: true,
        //     message: '请输入年龄',
        //     trigger: 'blur'
        // }, {
        //     type: 'number',
        //     min: 1,
        //     message: '请输入正确年龄',
        // }],
        // degreeInNature: [{
        //     required: true,
        //     message: '请选择学历性质',
        //     trigger: 'change'
        // }],
        // nation: [{
        //     required: true,
        //     message: '请选择学历民族',
        //     trigger: 'change'
        // }],
        // officeTel: [{
        //     required: true,
        //     validator: officeTelValidator,
        //     trigger: 'blur'
        // }],
        // nativePlace: [{
        //     required: true,
        //     message: '请选择籍贯',
        //     trigger: 'change'
        // }],
        // emergencyContact: [{
        //     required: true,
        //     message: '请输入紧急联系人',
        //     trigger: 'blur'
        // }],
        // politicsStatus: [{
        //     required: true,
        //     message: '请选择政治面貌',
        //     trigger: 'change'
        // }],
        // emergencyContactPhone: [{
        //     required: true,
        //     validator: phoneValidator,
        //     trigger: 'blur'
        // }],
        mobile: [{
          required: true,
          validator: phoneValidator,
          trigger: 'blur'
        }]
        // modeOfEmployment: [{
        //     required: true,
        //     message: '请选择用工方式',
        //     trigger: 'change'
        // }],
        // birthPlace: [{
        //     required: true,
        //     message: '请填写出生地',
        //     trigger: 'blur'
        // }],
        // prepareType: [{
        //     required: true,
        //     message: '请选择编制类型',
        //     trigger: 'change'
        // }],
        // certType: [{
        //     required: true,
        //     message: '请选择证件类型',
        //     trigger: 'change'
        // }],
        // isApplicable: [{
        //     required: true,
        //     message: '请选择是否使用统一用户平台',
        //     trigger: 'change'
        // }],
        // householdRegistrationType: [{
        //     required: true,
        //     message: '请选择户口性质',
        //     trigger: 'change'
        // }],
        // initDegree: [{
        //     required: true,
        //     message: '请填写初始学历',
        //     trigger: 'blur'
        // }],
        // initGraduationDate: [{
        //     required: true,
        //     message: '请选择初始学历毕业时间',
        //     trigger: 'change'
        // }],
        // initDegreeFromUniversity: [{
        //     required: true,
        //     message: '请选择初始学历毕业院校',
        //     trigger: 'change'
        // }],
        // initDegreeGraduationMajor: [{
        //     required: true,
        //     message: '请选择初始学历毕业专业',
        //     trigger: 'change'
        // }],
        // initAcademicOfStudy: [{
        //     required: true,
        //     message: '请选择初始学历学习形式',
        //     trigger: 'change'
        // }],
        // initOfSchooling: [{
        //     required: true,
        //     message: '请选择初始学历学制',
        //     trigger: 'change'
        // }],
        // initDegreeGraduate: [{
        //     required: true,
        //     message: '请填写初始学历学位',
        //     trigger: 'blur'
        // }],
        // initDiplomaCertNumber: [{
        //     required: true,
        //     message: '请填写初始学历毕业证编号',
        //     trigger: 'blur'
        // }],
        // initDegreeCertNumber: [{
        //     required: true,
        //     message: '请填写初始学历学位证书编号',
        //     trigger: 'blur'
        // }],
        // highestDegree: [{
        //     required: true,
        //     message: '请填写最高学历',
        //     trigger: 'blur'
        // }],
        // highestGraduationDate: [{
        //     required: true,
        //     message: '请选择最高学历毕业时间',
        //     trigger: 'change'
        // }],
        // highestDegreeFromUniversity: [{
        //     required: true,
        //     message: '请填写最高学历毕业院校',
        //     trigger: 'blur'
        // }],
        // highestDegreeGraduationMajor: [{
        //     required: true,
        //     message: '请选择最高学历毕业专业',
        //     trigger: 'change'
        // }],
        // highestAcademicOfStudy: [{
        //     required: true,
        //     message: '请选择最高学历学习形式',
        //     trigger: 'change'
        // }],
        // highestOfSchooling: [{
        //     required: true,
        //     message: '请选择最高学历学制',
        //     trigger: 'change'
        // }],
        // highestDegreeGraduate: [{
        //     required: true,
        //     message: '请填写最高学历学位',
        //     trigger: 'blur'
        // }],
        // highestDiplomaCertNumber: [{
        //     required: true,
        //     message: '请填写最高学历毕业证编号',
        //     trigger: 'blur'
        // }],
        // highestDegreeCertNumber: [{
        //     required: true,
        //     message: '请填写最高学历学位证书编号',
        //     trigger: 'blur'
        // }],
      },
      avatarUrl: '',
      userId: ''
    };
  },
  created: function created() {
    var userInfo = localStorage.getItem('admin.user');
    this.userId = JSON.parse(userInfo).userId;
    var login_mame = sessionStorage.getItem('login_name');
    this.getPersonnel(login_mame);
  },
  methods: {
    getPersonnel: function getPersonnel(login_mame) {
      var _this = this;
      getPersonnelList(login_mame).then(function (res) {
        var that = _this;
        Object.assign(_this.infoForm, res.data.data[0]);
        if (_this.mode != 'add' && _this.infoForm.signImgUrl != '' && _this.infoForm.signImgUrl != undefined) {
          that.fileList.push({
            uid: '1',
            url: config.baseUrl + that.infoForm.signImgUrl,
            thumbUrl: config.baseUrl + that.infoForm.signImgUrl,
            name: that.infoForm.signImgName,
            response: {
              data: {
                uid: '1',
                url: that.infoForm.signImgUrl,
                thumbUrl: that.infoForm.signImgUrl,
                name: that.infoForm.signImgName
              }
            }
          });
        }
        if (_this.mode != 'add' && _this.infoForm.avatarUrl != '' && _this.infoForm.avatarUrl != undefined) {
          that.fileListAvatar.push({
            uid: '1',
            url: config.baseUrl + that.infoForm.avatarUrl,
            thumbUrl: config.baseUrl + that.infoForm.avatarUrl,
            response: {
              data: {
                uid: '1',
                url: that.infoForm.avatarUrl,
                thumbUrl: that.infoForm.avatarUrl
              }
            }
          });
          _this.avatarUrl = config.baseUrl + that.infoForm.avatarUrl;
        }
      });
    },
    handleClick: function handleClick(index, id) {
      this.current = index;
      //锚点跳转
      document.getElementById(id).scrollIntoView();
    },
    encryption: function encryption(pas) {
      var key = CryptoJS.enc.Utf8.parse('MYYC-Hyd20220601'); //秘钥
      var srcs = CryptoJS.enc.Utf8.parse(pas);
      var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
      });
      return encrypted.toString();
    },
    save: function save() {
      var _this2 = this;
      var that = this;
      if (this.fileListAvatar.length > 0) {
        that.infoForm.avatarUrl = this.fileListAvatar[this.fileListAvatar.length - 1].response.data.url;
      }
      this.$refs.infoForm.validate(function (valid) {
        if (valid) {
          var idCard = that.infoForm.idCard;
          var pwd = idCard.substring(idCard.length - 6, idCard.length);
          that.infoForm.passWord = that.encryption(pwd);
          if (_this2.fileList.length > 0) {
            that.infoForm.signImgName = _this2.fileList[0].response.data.name;
            that.infoForm.signImgUrl = _this2.fileList[0].response.data.url;
          }
          savePersonnel(that.infoForm).then(function (res) {
            if (res.data.code == 200) {
              that.$message.success('新增成功');
              that.rutrnBack();
            }
          });
        } else {
          return false;
        }
      });
    },
    edit: function edit() {
      var that = this;
      if (this.fileList.length > 0) {
        that.infoForm.signImgName = this.fileList[0].response.data.name;
        that.infoForm.signImgUrl = this.fileList[0].response.data.url;
      }
      if (this.fileListAvatar.length > 0) {
        that.infoForm.avatarUrl = this.fileListAvatar[this.fileListAvatar.length - 1].response.data.url;
      }
      this.$refs.infoForm.validate(function (valid) {
        if (valid) {
          editPersonnel(that.infoForm).then(function (res) {
            if (res.data.code == 200) {
              that.$message.success('修改成功');
              that.rutrnBack();
            }
          });
        } else {
          return false;
        }
      });
    },
    rutrnBack: function rutrnBack() {
      this.$router.push('/system/dataMgr/perArchive');
    },
    resetPass: function resetPass(e) {
      var that = this;
      resetPassWord(that.infoForm).then(function (res) {
        if (res.data.code == 200) {
          that.$message.success('重置成功');
          that.rutrnBack();
        }
      });
    },
    resetPassCancel: function resetPassCancel(e) {},
    handleCancel: function handleCancel() {
      this.previewVisible = false;
    },
    handlePreview: function handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    handleChange: function handleChange(info) {
      if (info.file.status == 'removed') {
        this.$message.success('删除');
        this.fileList = info.fileList;
        this.infoForm.signImgUrl = undefined;
        this.infoForm.signImgName = undefined;
        return;
      }
      if (!info.file.name.includes('.jpg') && !info.file.name.includes('.png')) {
        this.$message.error('请上传正确格式');
        return;
      }
      this.fileList = info.fileList;
      if (info.file.response.code == 200) {
        this.$message.success('上传成功');
      } else {
        this.$message.error(info.file.response.message);
      }
    },
    getBase64: function getBase64(file) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          return resolve(reader.result);
        };
        reader.onerror = function (error) {
          return reject(error);
        };
      });
    },
    bodyScroll: function bodyScroll() {
      var _this3 = this;
      this.contentLocation.forEach(function (el, index) {
        if (_this3.$refs.infobody.scrollTop >= el - 500) {
          _this3.current = index;
        }
      });
    },
    throttle: function throttle(func, wait, mustRun) {
      var timeout,
        startTime = new Date();
      return function () {
        var context = this,
          args = arguments,
          curTime = new Date();
        clearTimeout(timeout);
        // 如果达到了规定的触发时间间隔，触发 handler
        if (curTime - startTime >= mustRun) {
          func.apply(context, args);
          startTime = curTime;
          // 没达到触发间隔，重新设定定时器
        } else {
          timeout = setTimeout(func, wait);
        }
      };
    },
    debounce: function debounce(func, wait, immediate) {
      var timeout;
      return function () {
        var context = this,
          args = arguments;
        var later = function later() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    handleLocation: function handleLocation() {
      var _this4 = this;
      this.contentLocation = [];
      if (Array.isArray(this.anchorList)) {
        this.anchorList.forEach(function (item) {
          _this4.contentLocation.push(document.querySelector("#".concat(item.id)).offsetTop);
        });
      }
    },
    handleChangeAvatar: function handleChangeAvatar(info) {
      if (info.file.status == 'removed') {
        this.$message.success('删除');
        this.fileListAvatar = info.fileList;
        return;
      }
      if (!info.file.name.includes('.jpg') && !info.file.name.includes('.png')) {
        this.$message.error('请上传正确格式');
        return;
      }
      this.fileListAvatar = info.fileList;
      if (info.file.response.code == 200) {
        this.$message.success('上传成功');
        this.avatarUrl = config.baseUrl + this.fileListAvatar[this.fileListAvatar.length - 1].response.data.url;
      } else {
        this.$message.error(info.file.response.message);
      }
    },
    showSignatureEditor: function showSignatureEditor() {
      var _this5 = this;
      this.signatureModalVisible = true;
      this.$nextTick(function () {
        setTimeout(function () {
          _this5.initSignatureCanvas();
        }, 200);
      });
    },
    initSignatureCanvas: function initSignatureCanvas() {
      var canvas = this.$refs.signatureCanvas;
      if (!canvas) return;

      // 设置固定宽度，避免parentElement.clientWidth为0
      canvas.width = 760; // 改为固定宽度
      canvas.height = 300;
      this.signatureCtx = canvas.getContext('2d');
      this.signatureCtx.lineWidth = 2;
      this.signatureCtx.lineCap = 'round';
      this.signatureCtx.lineJoin = 'round';
      this.signatureCtx.strokeStyle = '#000000';
    },
    startSignature: function startSignature(e) {
      var canvas = this.$refs.signatureCanvas;
      var rect = canvas.getBoundingClientRect();
      this.isSignatureDrawing = true;
      this.signatureLastX = e.clientX - rect.left;
      this.signatureLastY = e.clientY - rect.top;
    },
    drawSignature: function drawSignature(e) {
      if (!this.isSignatureDrawing) return;
      var canvas = this.$refs.signatureCanvas;
      var rect = canvas.getBoundingClientRect();
      var x = e.clientX - rect.left;
      var y = e.clientY - rect.top;
      this.signatureCtx.beginPath();
      this.signatureCtx.moveTo(this.signatureLastX, this.signatureLastY);
      this.signatureCtx.lineTo(x, y);
      this.signatureCtx.stroke();
      this.signatureLastX = x;
      this.signatureLastY = y;
    },
    endSignature: function endSignature() {
      this.isSignatureDrawing = false;
    },
    clearSignatureCanvas: function clearSignatureCanvas() {
      if (this.signatureCtx) {
        var canvas = this.$refs.signatureCanvas;
        this.signatureCtx.clearRect(0, 0, canvas.width, canvas.height);
      }
    },
    saveSignature: function saveSignature() {
      var that = this;
      var canvas = this.$refs.signatureCanvas;
      var imageData = canvas.toDataURL('image/png');

      // 将base64转换为blob
      var arr = imageData.split(',');
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      var blob = new Blob([u8arr], {
        type: 'image/png'
      });
      var file = new File([blob], 'signature.png', {
        type: 'image/png'
      });

      // 创建 FormData
      var formData = new FormData();
      formData.append('file', file);

      // 上传
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'api/personArchivesController/uploadImg');
      xhr.setRequestHeader('Authorization', sessionStorage.getItem('token'));
      xhr.onload = function () {
        var response = JSON.parse(xhr.responseText);
        if (response.code === 200) {
          // 添加到fileList
          that.fileList = [{
            uid: '-1',
            name: response.data.name,
            status: 'done',
            response: response,
            url: config.baseUrl + response.data.url,
            thumbUrl: config.baseUrl + response.data.url
          }];
          that.$message.success('签名上传成功');
          that.signatureModalVisible = false;

          // 调用updateUserSignature接口保存签名
          updateUserSignature({
            url: response.data.url,
            name: response.data.name,
            userId: that.userId
          }).then(function (res) {
            if (res.data.code == 200) {
              that.$message.success('签名保存成功');
            }
          });
        } else {
          that.$message.error(response.message || '签名上传失败');
        }
      };
      xhr.onerror = function () {
        that.$message.error('签名上传失败');
      };
      xhr.send(formData);
    }
  },
  mounted: function mounted() {
    this.headers = {
      Authorization: sessionStorage.getItem('token')
    };
    this.handleLocation();
    var that = this;
    var query = this.$route.query;
    // this.mode = query.mode;
    Object.assign(this.infoForm, query.detail);
    if (this.mode != 'add' && this.infoForm.signImgUrl != '' && this.infoForm.signImgUrl != undefined) {
      that.fileList.push({
        uid: '1',
        url: config.baseUrl + that.infoForm.signImgUrl,
        thumbUrl: config.baseUrl + that.infoForm.signImgUrl,
        name: that.infoForm.signImgName,
        response: {
          data: {
            uid: '1',
            url: that.infoForm.signImgUrl,
            thumbUrl: that.infoForm.signImgUrl,
            name: that.infoForm.signImgName
          }
        }
      });
    }
    if (this.mode != 'add' && this.infoForm.avatarUrl != '' && this.infoForm.avatarUrl != undefined) {
      that.fileListAvatar.push({
        uid: '1',
        url: config.baseUrl + that.infoForm.avatarUrl,
        thumbUrl: config.baseUrl + that.infoForm.avatarUrl,
        response: {
          data: {
            uid: '1',
            url: that.infoForm.avatarUrl,
            thumbUrl: that.infoForm.avatarUrl
          }
        }
      });
      this.avatarUrl = config.baseUrl + that.infoForm.avatarUrl;
    }
    // //民族
    // getDictNotTreeByCateId(1).then(res => {
    //     if (res.data.code == 200) {
    //         that.nationDict = res.data.data;
    //     }
    // });
    // //健康状况
    // getDictTreeByCateId(5).then(res => {
    //     if (res.data.code == 200) {
    //         that.healthDict = res.data.data;
    //         that.healthDictTree = that.healthDict.filter(item => item.children.length > 0);
    //         that.healthDictOpt = that.healthDict.filter(item => item.children.length <= 0);
    //     }
    // });
    // //婚姻状况
    // getDictNotTreeByCateId(6).then(res => {
    //     if (res.data.code == 200) {
    //         that.marriageDict = res.data.data;
    //     }
    // });
    // //学历性质
    // getDictNotTreeByCateId(8).then(res => {
    //     if (res.data.code == 200) {
    //         that.degreeNatureDict = res.data.data;
    //     }
    // });
    // //籍贯
    // getDictNotTreeByCateId(2).then(res => {
    //     if (res.data.code == 200) {
    //         that.nativePlaceDict = res.data.data;
    //     }
    // });
    // //政治面貌
    // getDictNotTreeByCateId(7).then(res => {
    //     if (res.data.code == 200) {
    //         that.politicsStatusDict = res.data.data;
    //     }
    // });
    // //用工方式
    // getDictNotTreeByCateId(12).then(res => {
    //     if (res.data.code == 200) {
    //         that.modeOfEmploymentDict = res.data.data;
    //     }
    // });
    // //编制类型
    // getDictNotTreeByCateId(16).then(res => {
    //     if (res.data.code == 200) {
    //         that.prepareTypeDict = res.data.data;
    //     }
    // });
    // //证件类型
    // getDictNotTreeByCateId(3).then(res => {
    //     if (res.data.code == 200) {
    //         that.certTypeDict = res.data.data;
    //     }
    // });
    // //户口性质
    // getDictNotTreeByCateId(4).then(res => {
    //     if (res.data.code == 200) {
    //         that.householdRegistrationTypeDict = res.data.data;
    //     }
    // });
    // //学制 学位 学历
    // getDictNotTreeByCateId(11).then(res => {
    //     if (res.data.code == 200) {
    //         that.initOfSchoolingDict = res.data.data;
    //     }
    // });
    // //学习形式
    // getDictNotTreeByCateId(9).then(res => {
    //     if (res.data.code == 200) {
    //         that.initAcademicOfStudyDict = res.data.data;
    //     }
    // });
    // //所属层级
    // getDictTreeByCateId(15).then(res => {
    //     if (res.data.code == 200) {
    //         that.levelDict = res.data.data;
    //         that.levelDictTree = that.levelDict.filter(item => item.children.length > 0);
    //         that.levelDictOpt = that.levelDict.filter(item => item.children.length <= 0);
    //     }
    // });
    // //专业
    // getDictNotTreeByCateId(10).then(res => {
    //     if (res.data.code == 200) {
    //         that.graduationMajorDict = res.data.data;
    //     }
    // });
  }
};